import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import moment from 'moment'
import { withAuth } from '../AuthContext'
import { withSearch } from '../SearchContext'
import Cookies from 'universal-cookie'
import { setPricing, getCurrencySign } from '../../utils/utils'
import { Button } from 'react-bootstrap'
import { decode } from 'html-entities'
import { isInPhoneScreen } from '../../utils/utils'
import { gaEvents } from '../../analytics/events'

const cookies = new Cookies()

class RecipientProfile extends Component {
  constructor(props) {
    super(props)
    const u = this.props.auth.user
    this.state = {
      emailVerificationSent: false,
      loading: false,
      responseMessage: null,
      errorMessage: null,
      priceData: null,
      currencySign: null,
      membershipFee: u.membershipFee,
      user: u,
    }
    this.cancelSubscription = this.cancelSubscription.bind(this)
    this.chooseMembershipFee = this.chooseMembershipFee.bind(this)
    this.requestEmail = this.requestEmail.bind(this)
    this.phoneScreen = this.phoneScreen
  }

  requestEmail() {
    this.setState({ emailLoading: true })
    axios
      .post('/api/verify-email')
      .then((response) => {
        this.setState({ emailVerificationSent: true })
      })
      .catch(function (error) {
        console.log('Request failure: ', error)
      })
      .finally(() => {
        this.setState({ emailLoading: false })
      })
  }

  componentDidUpdate() {
    //this.props.auth.refreshUser();
    const u = this.props.auth.user
  }

  componentDidMount() {
    console.log('>>>>> componentDidMount')

    if (!this.props.auth.user) {
      console.log('no user...')
    }

    const getPricing = async () => {
      const data = await setPricing(
        this.props.auth.user.currencyValue,
        this.props.auth.user.discountCode
      )
      this.setState({
        priceData: data.membershipFee.toString(),
      })
    }
    const getCurrency = async () => {
      const data = await getCurrencySign(this.props.auth.user.currencyValue)
      this.setState({
        currencySign: data.sign,
      })
    }
    getPricing()
    getCurrency()
  }

  cancelSubscription() {
    this.setState({ loading: true })
    const that = this
    axios
      .post('/api/cancel/subscription')
      .then((response) => {
        this.props.auth.refreshUser()
        that.setState({
          responseMessage: 'Your subscription has been cancelled successfully',
        })
      })
      .catch(function (error) {
        that.setState({
          errorMessage: 'Error trying to cancel your subscription',
        })
      })
      .finally(() => this.setState({ loading: false }))
  }

  chooseMembershipFee(event) {
    event.preventDefault()
    gaEvents.eventGeneric(
      'button_click',
      'choose-membership-fee-button-clicked',
      this.state.user.id + ' - profile page - button - choose membership fee'
    )

    this.props.history.push('/dashboard/choose-membership-fee')
  }

  render() {
    const u = this.props.auth.user

    let country = this.props.search.countries.find((c) => c.id === u.countryId)
    country = country ? country.nicename : null

    const favInfo = [
      { name: 'favoBook', label: 'Book or author' },
      { name: 'favoFilm', label: 'Film' },
      { name: 'favoActor', label: 'Actor or actress' },
      { name: 'favoMusician', label: 'Musician or band' },
      { name: 'favoPlace', label: 'Travel destination' },
      { name: 'favoFood', label: 'Type of food' },
      { name: 'favoExercise', label: 'Sport or exercise' },
      { name: 'favoHero', label: 'Hero or heroine' },
    ]

    const favs = favInfo
      .filter((f) => u[f.name])
      .map((f) => (
        <div key={f.name} className="favs">
          {f.label}: {u[f.name]} <br />
        </div>
      ))

    const ProgressSection = ({ u }) => {
      if (u.status == 'registered') {
        return (
          <div className="profile-wrapper text-center progress-box">
            <div className="progress-intro">
              <h4>Hi {u.forename}</h4>
              <p>Welcome to Freebird Club!</p>
            </div>
            <div className="progress-wrapper">
              <div className="progress-line">
                <div className="position-dot"></div>
                <p className="position-text">YOU ARE HERE</p>

                <img
                  src="/images/icons/profile/green-tick.svg"
                  alt=""
                  className="progress-1"
                />
                <img
                  src="/images/icons/profile/orange-clock.svg"
                  alt=""
                  className="progress-2"
                />
                <img
                  src="/images/icons/profile/grey-house.svg"
                  alt=""
                  className="progress-3"
                />
              </div>
              <div className="progress-labels">
                <p className="label-1">You have signed up</p>
                <p className="label-2">
                  Now add your profile information & choose membership fee
                </p>
                <p className="label-3">
                  After your account is approved you will be a verified member!
                </p>
                <Link className="progress-link" to="#">
                  Why do I need to do this?
                  <img
                    src="/images/icons/profile/green-arrow.svg"
                    alt=""
                    className="progress-link-arrow"
                  />
                </Link>
              </div>
            </div>
          </div>
        )
      }
    }

    const IntroSection = ({ u }) => {
      if (u.status == 'approvedfinal') {
        return (
          <div className="profile-wrapper">
            <div>
              <p>
                Your Freebird account is now fully activated and you are able to
                send direct messages to other members. Thank you for providing
                your photo ID!
              </p>
            </div>
          </div>
        )
      } else if (u.status == 'approved') {
        return (
          <div className="profile-wrapper">
            <div>
              <p>
                Your Freebird account has been activated and your profile has
                been approved. You now have access to view Freebird Club
                member's full profiles. In order to message members you will be
                requested to upload a photo ID. This is important to ensure all
                Freebird members are accounted for as genuine humans and helps
                ensure the safety of our community. You will only be asked to
                upload a photo ID if you choose to directly message someone. In
                the meantime welcome to Freebird Club!
              </p>
            </div>
          </div>
        )
      } else if (u.status == 'partiallycompleted') {
        return (
          <div className="profile-wrapper">
            <div>
              <p>
                Your Freebird profile is now complete and your account has been
                sent for approval. This important step helps maintain standards
                of profile integrity and security for all members. The approval
                process is manual and may take up to 24 hours to complete, but
                we always try to move things along as quickly as possible. We
                will inform you by email when the approval process is complete.
              </p>
            </div>
          </div>
        )
      } else if (u.status == 'completed') {
        return (
          <div className="profile-wrapper">
            <div>
              <p>
                Thank you for uploading your proof of identity. It has been sent
                to our admin team for approval. The approval process is manual
                and may take up to 24 hours to complete, but we always try to
                move things along as quickly as possible. We will inform you by
                email when the approval process is complete.
              </p>
              {/*
                            <p>
                                Now you can discover Freebird destinations, connect with
                                hosts and even become a Freebird host yourself by
                                clicking the button below.
                            </p>
                            <Link to="/dashboard/host-signup">
                                <button className="btn btn-primary">
                                    Become a host
                                </button>
                            </Link>
                            */}
            </div>
          </div>
        )
      } else if (u.status == 'registered') {
        return (
          <div className="profile-wrapper">
            <div>
              <p>
                Your account has been created. In order to complete your
                profile, please provide the information detailed below.
              </p>
            </div>
          </div>
        )
      }
    }

    if (!u.status || !this.state.priceData || !this.state.currencySign) {
      return null
    }
    return (
      <section className="contact-wrapper">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="contact_form">
                {/* This is the normal customer graphic, need to change this for the recipient-specific one
                                <ProgressSection u={u} />
                                */}
                <IntroSection u={u} />
                {u.status === 'approved' || u.status === 'approvedfinal' ? (
                  <div className="profile-wrapper">
                    <h4 className="profile-title">Your identity</h4>
                    <h6>Name</h6>
                    <p>
                      {u.title} {u.forename} {u.surname}
                    </p>
                    {/*}
                                        <h6>Date of birth</h6>
                                        <p>{moment(u.dob).format('DD/MM/YYYY')}</p>
                                        */}
                    <h6>Country</h6>
                    <p>{country}</p>
                    {u.status === 'approved' ? (
                      u.proofIdentityStatus === 'completed' ? (
                        <div>
                          <div className="row pb-3 ml-1">
                            <span className="badge badge-success">
                              <i className="fa fa-check" /> Proof of identity
                              has been provided
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div className="row pb-3 ml-1">
                            <span className="badge badge-warning">
                              <i className="fa fa-exclamation-triangle" />{' '}
                              Identity not verified
                            </span>
                          </div>
                          <div className="row ml-1">
                            <Link to="/dashboard/proof-identity">
                              <button className="btn btn-primary">
                                Upload Proof of Identity
                              </button>
                            </Link>
                          </div>
                        </div>
                      )
                    ) : (
                      ''
                    )}
                    <hr />
                    {u.status !== 'approved' &&
                      u.status !== 'approvedfinal' && (
                        <div className="row pb-3 ml-1 hidden">
                          <span className="badge badge-warning">
                            <i className="fa fa-exclamation-triangle" />
                            Your profile must be approved
                          </span>
                        </div>
                      )}
                    <div className="btn-toolbar">
                      <Link to="/dashboard/edit-identity">
                        <button className="btn btn-primary mr-2">
                          Edit Identity
                        </button>
                      </Link>
                      <button className="btn btn-primary hidden">
                        Change Password
                      </button>
                    </div>
                  </div>
                ) : null}
                <div className="profile-wrapper">
                  <h4 className="profile-title">Your profile photo</h4>
                  <h6>Profile photo</h6>
                  {u.profilePhotoStatus === 'completed' ? (
                    <div>
                      <img
                        className="img-fluid img-profile-preferences"
                        // src="http://s3-eu-west-1.amazonaws.com/freebird-uploads-production/gfx/users/photo_s/1474999448390189556_1004743697380_6080876_n.jpg"
                        src={`${s3AwsEndpoint}/${u.profilePhotoO}`}
                      />
                      <hr />
                      <Link to="/dashboard/photo">
                        <button className="btn btn-primary">
                          Change Profile Photo
                        </button>
                      </Link>
                    </div>
                  ) : (
                    <div>
                      <p>None provided</p>
                      <span className="badge badge-warning">
                        <i className="fa fa-exclamation-triangle" /> Please
                        upload a profile photo
                      </span>
                      <hr />
                      <Link to="/dashboard/photo">
                        <button className="btn btn-primary">
                          Upload Profile Photo
                        </button>
                      </Link>
                    </div>
                  )}
                </div>
                <div className="profile-wrapper">
                  <h4 className="profile-title">Your email</h4>
                  <h6>Email</h6>
                  <p>{u.email}</p>
                  {u.emailStatus === 'verified' ? (
                    <span className="badge badge-success">
                      <i className="fa fa-check" /> Email address verified
                    </span>
                  ) : (
                    <div>
                      <div className="row pb-3 ml-1">
                        <span className="badge badge-warning">
                          <i className="fa fa-exclamation-triangle" /> Email
                          address not verified
                        </span>
                      </div>
                      <div className="row ml-1">
                        {!this.state.emailVerificationSent ? (
                          this.state.emailLoading ? (
                            <button
                              className="btn btn-primary"
                              type="button"
                              disabled
                            >
                              Sending{' '}
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              />
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary"
                              onClick={this.requestEmail}
                            >
                              Resend Verification Email
                            </button>
                          )
                        ) : (
                          <button className="btn btn-primary" disabled>
                            Verification Email Sent
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                  <hr />

                  <Link to="/dashboard/edit-email">
                    <button className="btn btn-primary">
                      Edit Email Address
                    </button>
                  </Link>
                </div>
                <div className="profile-wrapper">
                  <h4 className="profile-title">Your phone number</h4>
                  <h6>Phone number</h6>
                  <div>
                    {u.phoneCodeId && u.phone ? (
                      `+ ${u.phoneCodeId} - ${u.phone}`
                    ) : u.phone ? (
                      `${u.phone}`
                    ) : (
                      <div>
                        <p>'None provided'</p>
                        <span className="badge badge-warning">
                          <i className="fa fa-exclamation-triangle" /> Please
                          add your phone number
                        </span>
                      </div>
                    )}
                  </div>

                  {u.phoneStatus === 'verified' ? (
                    <span className="badge badge-success">
                      <i className="fa fa-check" /> Phone number verified
                    </span>
                  ) : u.phoneCodeId && u.phone ? (
                    <div>
                      <div className="row pb-3 ml-1">
                        <span className="badge badge-warning">
                          <i className="fa fa-exclamation-triangle" /> Phone
                          number not verified
                        </span>
                      </div>
                      <div className="row ml-1">
                        <Link to="/dashboard/edit-phonenumber/Verify">
                          <button className="btn btn-primary">Verify</button>
                        </Link>
                      </div>
                    </div>
                  ) : null}
                  <hr />

                  <Link to="/dashboard/edit-phonenumber">
                    <button className="btn btn-primary">
                      Edit Phone Number
                    </button>
                  </Link>
                </div>
                <div className="profile-wrapper">
                  <h4 className="profile-title">Your profile information</h4>
                  <h6>Introduction</h6>
                  <p>{u.introduction ? u.introduction : 'Not completed'}</p>
                  <h6>Interests</h6>
                  <p>{u.interest ? u.interest : 'Not completed'}</p>
                  {u.philosophyStatus && u.philosophyStatus != 'pending' ? (
                    <h6>Philosophy</h6>
                  ) : null}
                  <p>{u.philosophy}</p>
                  {u.favoStatus && u.favoStatus != 'pending' ? (
                    <div>
                      <h6>Favourites</h6>

                      {favs}
                    </div>
                  ) : null}
                  {u.introductionStatus === 'completed' &&
                  u.interestStatus === 'completed' ? (
                    <span className="badge badge-success">
                      <i className="fa fa-check" /> Profile complete
                    </span>
                  ) : (
                    <div>
                      <div className="row pb-3 ml-1">
                        <span className="badge badge-info">
                          Profile needs more information
                        </span>
                      </div>
                      <div className="row ml-1">
                        <p>
                          <b>
                            {' '}
                            Please complete both the introduction and interests
                            sections{' '}
                          </b>
                        </p>
                      </div>
                    </div>
                  )}
                  <hr />
                  <Link to="/dashboard/edit-profile">
                    <button className="btn btn-primary"> Edit Profile</button>
                  </Link>
                </div>
                <div className="profile-wrapper">
                  <h4 className="profile-title">Pay As You Wish</h4>
                  {u.membershipFeeStatus === 'completed' ? (
                    <div>
                      <p>
                        Your lifetime membership was gifted to you by&nbsp;
                        {u.custodian.full_name}
                      </p>
                      {u.membershipFee === 0 && (
                        <div>
                          <hr />
                          <Link to="/dashboard/choose-membership-fee">
                            <button className="btn btn-primary">
                              Change Membership Fee
                            </button>
                          </Link>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      <img
                        src="/images/profile/were-open.png"
                        alt=""
                        className="img-were-open"
                      />
                      <p>
                        We want Freebird to be as inclusive as possible, and
                        don’t want price to be a barrier. As such we have a "pay
                        as you wish" membership model where you can pay whatever
                        you think it is worth for a full year’s membership.
                      </p>
                      <p>
                        We merely ask you to consider that running a thriving
                        club that provides real value to its members requires
                        funds to develop and maintain. We trust we can achieve
                        that together.
                      </p>
                      <p>
                        <i>
                          Unlike some companies, we don’t make money from
                          showing ads to our members or from selling members'
                          data, so we have an annual membership fee to help
                          cover the costs of running the club. This fee also
                          acts as a deterrant for trolls and con-artists,
                          helping to keep Freebird safe for our members.
                        </i>
                      </p>
                      <p>Thanks for reading.</p>
                      <span className="badge badge-warning">
                        <i className="fa fa-exclamation-triangle" /> Please
                        choose a membership fee
                      </span>
                      <hr />
                      <Link
                        to="/dashboard/choose-membership-fee"
                        onClick={this.chooseMembershipFee}
                      >
                        <button className="btn btn-primary">
                          Choose Membership Fee
                        </button>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default withRouter(withAuth(withSearch(RecipientProfile)))
